<template>
  <div v-if="!loading" class="container-fluid d-flex flex-column h-100">
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>Nástenka</h2>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
    }
  },
}
</script>
